import { useQuery } from "@apollo/client/react";

import { GET_SCAN_CREATION_REQUIREMENTS } from "./gql";

const useScanCreationRequirements = () => {
  const { data, error, loading, refetch } = useQuery(GET_SCAN_CREATION_REQUIREMENTS);

  const hasAttachableIntegration = !!data?.awsIntegrations.length;
  const hasAttachableWorkerPool = !!data?.workerPools.length;

  return { hasAttachableIntegration, hasAttachableWorkerPool, error, loading, refetch };
};

export default useScanCreationRequirements;
